//Library
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { checkValidity } from '../../../shared/utility';
import { load_user_details } from '../../../store/actions/auth';
import { update_training } from '../../../store/actions/train';
import routes from '../../../config/routes';

//Components
import Input from '../../UI/Input/Input';

function UpdateTraining({load_user_details, update_training, user, isAuthenticated}) {

    //STATE
    const [loader, setLoader] = useState(true);
    const [selectedFile, setSelectedFile] = useState()
    const [training, setTraining] = useState();

    const active = [
        {value: '', displayValue: ''},
        {value: true, displayValue: "ACTIVE"},
        {value: false, displayValue: "INACTIVE"},
    ]

    //State
    const [inputs, setInputs] = useState({
        name: {
            elementType: 'input',
            elementConfig: {
                type: 'name',
                placeholder: 'Titre'
            },
            value: '',
            label: 'Titre',
            valid: true,
            validation: {
                maxLength: 150,
            },
            touched: false,
            errorMessage: "Champ requis - 150 caractères au maximum"
        },
        description: {
            elementType: 'textarea',
            elementConfig: {
                type: 'name',
                placeholder: 'Description'
            },
            value: '',
            label: 'Description',
            valid: true,
            validation: {
                maxLength: 150,
            },
            touched: false,
            errorMessage: "Champ requis - 150 caractères au maximum"
        },
        start: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                placeholder: '__-__-____'
            },
            value: '',
            label: 'Date de début',
            valid: true,
            validation: {

            },
            touched: false,
            errorMessage: "Champ requis"
        },
        end: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                placeholder: '__-__-____'
            },
            value: '',
            label: 'Date de fin',
            valid: true,
            validation: {

            },
            touched: false,
            errorMessage: "Champ requis"
        },
        is_active: {
            elementType: 'select',
            elementConfig: {
                type: 'name',
                placeholder: "",
                options: active
            },
            value: '',
            label: "Statut de la formation",
            valid: true,
            validation: {

            },
            touched: false,
            errorMessage: "Champ requis",
        },
        thumbnail: {
            elementType: 'input',
            elementConfig: {
                type: 'file',
                placeholder: ''
            },
            value: '',
            label: "Image ou photo",
            valid: true,
            validation: {
                noRules: true,
            },
            touched: false,
            errorMessage: "Champs requis"
        }
    });

    const [valid, setValid] = useState(false);

    //Functions

    const InputChangedHandler = (event, id) => {

        //Change Value
        const newInputs = {...inputs};
        newInputs[id].value = event.target.value;
        newInputs[id].touched = true;

        if(newInputs[id].elementConfig.type === 'file'){
            setSelectedFile(event.target.files[0]);
        }

        //Check value
        newInputs[id].valid = checkValidity(event.target.value, newInputs[id].validation)

        setInputs(newInputs);

        //Form checking
        let formIsValid = true;
        for (let input in newInputs) {
            formIsValid = newInputs[input].valid && formIsValid;
        }
        setValid(formIsValid);
    };

    const formHandler = event => {
        event.preventDefault();
    }

    //ComponentDidMount
    useEffect(() => {
        load_user_details();
        const auth = localStorage.getItem('authenticated');
        if (! auth){
            navigate(routes.HOME)
            alert('vous devez vous connecter pour accéder à votre profil')
        }
    }, [])

    //ComponentDidUpdate
     useEffect(() => {
        const auth = localStorage.getItem('authenticated');
        if (! auth){
            navigate(routes.HOME)
            alert('vous devez vous connecter pour accéder à votre profil')
        }
        if (!user){
            navigate(routes.LOGIN)
        }
        else {
            if (user.is_front_admin === false){
                navigate(routes.HOME)
            }
            const storedTraining = JSON.parse(sessionStorage.getItem('training_to_update'))
            if (storedTraining) {
                setTraining(storedTraining)
            }
        }
    }, []);

    //Preload form data
    const load = () => {
        if (!training) return null;

        inputs.name.elementConfig.placeholder = training.name;
        inputs.description.elementConfig.placeholder = training.description
        inputs.start.label = "Date de Début : " + training.start_date;
        inputs.end.label = "Date de Fin : " + training.end_date;
        inputs.thumbnail.label = "Image actuelle : " + training.thumbnail
        const is_active = training.is_active;
        if (is_active){
            inputs.is_active.label = "La formation est ACTIVE"
        }
        else{
            inputs.is_active.label = "La formation est ACTIVE"
        }
    }
    const prefetch_data = load()
    //Redirect
    const navigate = useNavigate();

    //Confirm Register
    const registerClickedHandler = () => {
        if (!training) return

        const train = {
            id: training.pk,
            name: inputs.name.value,
            description: inputs.description.value,
            start_date: inputs.start.value,
            end_date: inputs.end.value,
            is_active: inputs.is_active.value,
            thumbnail: selectedFile,
        };

        try{
            update_training(train.id, train.name, train.description, train.start_date, train.end_date, train.is_active, train.thumbnail);
            navigate(routes.TRAININGS);
        }
        catch(err){
            alert("Vérifiez que l'ensemble des champs soient renseignés")
        }

    }

    //Variables

    const formElementArray = [];
    for(let key in inputs) {
        formElementArray.push({
            id: key,
            config: inputs[key]
        });
    };

    let form = (
        <form onSubmit={(e) => formHandler(e)}>
            {formElementArray.map(formElement => (
                <div className="row d-flex justify-content-center mt-5" key={formElement.id}>
                    <Input
                        key={formElement.id}
                        id={formElement.id}
                        value={formElement.config.value}
                        label={formElement.config.label}
                        type={formElement.config.elementType}
                        config={formElement.config.elementConfig}
                        valid={formElement.config.valid}
                        touched={formElement.config.touched}
                        errorMessage={formElement.config.errorMessage}
                        changed={(e) => InputChangedHandler(e, formElement.id)}
                        proposal_A={formElement.config.proposal_A}
                        proposal_B={formElement.config.proposal_B}
                    />
                </div>
            ))}
            <div className="row d-flex justify-content-center">
                <img src={training ? training.thumbnail : ""} className="img img-fluid" alt="thumbnail"/>
            </div>
            <div className='row d-flex justify-content-center gy-3 mt-5 mb-5'>
                <button
                    type='button'
                    className='signupBtn'
                    onClick={registerClickedHandler}
                >
                    <span className='signupBtnSpan RobotoBold'>Enregistrer</span>
                </button>
            </div>
        </form>
    );


    return (
        <div className='container-fluid'>
            <div className='row d-flex justify-content-center my-5'>
            <h1 className='text-center mt-5 PoppinsLight or'>Mise à jour de formation</h1>
            <h3 className="PoppinsLight purple">(Ne renseigner que les champs à modifier)</h3>
                <div className='col-12 col-md-6'>
                    {prefetch_data}
                    {form}
                </div>
            </div>
        </div>
    )
};

const mapStateToProps = state => ({
    user: state.auth.user,
    isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { load_user_details, update_training }) (UpdateTraining);